export const dbURL = "https://api2204.musicthisday.com/";
export const dbURLlocal = "http://localhost:3002/";